export const validateForm = (fullName, mobile, email, org, message) => {
  let fields = {
    fullName: false,
    mobile: false,
    email: false,
    org: false,
    message: false,
  };

  const emailRegx =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      email
    );

  if (fullName) {
    fields.fullName = true;
  }
  if (email) {
    fields.email = emailRegx;
  }
  if (mobile && mobile.length == 10) {
    fields.mobile = true;
  }
  if (org) {
    fields.org = true;
  }
  if (message) {
    fields.message = true;
  }

  return fields;
};
